function normalizeUserLocale(rawLocale: string) {
  const normalized = rawLocale.trim().replace(/_/g, '-').toLowerCase();

  if (!normalized) return null;
  if (normalized.startsWith('ko')) return 'ko';
  if (normalized.startsWith('en')) return 'en';
  if (normalized.startsWith('ja') || normalized.startsWith('jp')) return 'jp';
  if (normalized === 'zhtw' || normalized === 'zh-tw' || normalized === 'zh-hk') {
    return 'zh-TW';
  }
  if (normalized === 'zhcn' || normalized === 'zh-cn') return 'zh-CN';
  if (normalized.startsWith('zh')) {
    if (normalized.includes('hant') || normalized.includes('tw') || normalized.includes('hk')) {
      return 'zh-TW';
    }
    return 'zh-CN';
  }

  return null;
}

export function getUserLocale() {
  const primaryLanguage =
    navigator.languages && navigator.languages.length > 0 ? navigator.languages[0] : null;
  const browserLanguage = navigator.language || null;

  const rawLocale =
    primaryLanguage && primaryLanguage !== 'unknown'
      ? primaryLanguage
      : browserLanguage && browserLanguage !== 'unknown'
        ? browserLanguage
        : null;

  if (!rawLocale) return null;

  return normalizeUserLocale(rawLocale);
}
